import { AssetChubbBookingBannerInterface } from '@app/entities/asset-chubb-booking-banner';
import { AssetChubbBookingBannerBase } from './asset-chubb-booking-banner.base';

export const AssetChubbBookingBanner: AssetChubbBookingBannerInterface = {
  ...AssetChubbBookingBannerBase,
  ENABLED_FREE_ASSISTANCE: {
    TYPES: [],
    IS_NATIONAL_TRIP: false,
    IS_INTERNATIONAL_TRIP: false,
    ONLY_PRIME_USER: false,
  },
  ENABLED_ASSISTANCE_INTERFACE: [],
  LATERAL_BANNER: null,
};
